import React, { useEffect } from 'react';
import { ExpenseDashboard } from './ExpenseDashboard';
import { ExpenseClaimForm } from './ExpenseClaimForm';
import { ExpenseClaimsList } from './ExpenseClaimsList';
import { ExpenseApproval } from './ExpenseApproval';
import { ExpenseReports } from './ExpenseReports';
export function ExpenseManagement({
  locale = 'en-US',
  currentView
}) {
  // Make setCurrentView available globally for child components
  useEffect(() => {
    window.setCurrentView = view => {
      // In a real app, this would use a proper router or state management
      const event = new CustomEvent('changeView', {
        detail: {
          view
        }
      });
      window.dispatchEvent(event);
    };
    return () => {
      delete window.setCurrentView;
    };
  }, []);
  // Render the appropriate component based on the currentView
  const renderContent = () => {
    switch (currentView) {
      case 'expense-claims':
      case 'expense-claim-detail':
        return <ExpenseClaimsList locale={locale} onViewExpense={expense => window.setCurrentView('expense-claim-detail')} data-id="element-6440" />;
      case 'add-expense-claim':
        return <ExpenseClaimForm locale={locale} data-id="element-6441" />;
      case 'expense-approval':
        return <ExpenseApproval locale={locale} data-id="element-6442" />;
      case 'expense-reports':
        return <ExpenseReports locale={locale} data-id="element-6443" />;
      case 'expense-management':
      default:
        return <ExpenseDashboard locale={locale} data-id="element-6444" />;
    }
  };
  return <div data-id="element-6445">{renderContent()}</div>;
}